<template>
  <div style="display: flex; justify-content: space-between; flex-wrap: wrap">
    <div class="row-1">
      <div class="section-field" v-show="configInputs != 0">
        <label> Número RRIM </label>
        <input
          v-model="v$.dados.IGRRIM.$model"
          :class="[
            'field',
            {
              error:
                v$.dados.IGRRIM.$model == '' ? true : v$.dados.IGRRIM.$error,
            },
          ]"
          :disabled="configInputs != 0"
        />
        <div
          class="text-red"
          v-if="v$.dados.IGRRIM.$model == '' ? true : v$.dados.IGRRIM.$error"
        >
          O campo RRIM é obrigatório.
        </div>
      </div>

      <div class="section-field">
        <label> Código do Molde </label>
        <input
          @change="mapMoldSap(this.dados.IGMolde)"
          list="listMoldeInfor"
          v-model="v$.dados.IGMolde.$model"
          type="text"
          :placeholder="configInputs == 0 ? 'Digite o código' : ''"
          :class="['field', { error: v$.dados.IGMolde.$error }]"
          :disabled="configInputs"
        />
        <div v-if="validationMolde === true" class="text-red">
          Molde não encontrado no SAP.
        </div>
        <div class="text-red" v-if="v$.dados.IGMolde.$error">
          O campo Número Molde é obrigatório.
        </div>
        <datalist id="listMoldeInfor">
          <option
            v-for="(l, index) in listMoldes"
            :key="index"
            :value="l.codigoMolde"
          ></option>
        </datalist>
      </div>
      <div class="section-field">
        <label class=""> Número da Nota Fiscal </label>
        <input
          v-model="dados.IGNF"
          :placeholder="configInputs == 0 ? 'Digite o número' : ''"
          v-maska="[
            '#### #### #### #### #### #### #### #### #### #### ####',
            '',
          ]"
          class="field"
          :disabled="configInputs"
        />
      </div>
      <div @keydown.enter.stop class="section-field">
        <label class=""> Cliente </label>
        <input
          :disabled="configInputs"
          v-model="v$.dados.IGCliente.$model"
          :placeholder="configInputs == 0 ? 'Digite o cliente' : ''"
          type="text"
          :class="['field', { error: v$.dados.IGCliente.$error }]"
        />
        <div class="text-red" v-if="v$.dados.IGCliente.$error">
          O campo Cliente é obrigatório.
        </div>
      </div>

      <div class="section-field">
        <label class=""> Fabricante do Molde </label>
        <input
          v-model="dados.IGFM"
          type="text"
          :placeholder="configInputs == 0 ? 'Digite o fabricante' : ''"
          class="field"
          :disabled="configInputs"
        />
      </div>
      <div class="section-field">
        <label class=""> Emissão de Nota Fiscal </label>
        <input
          v-model="dados.IGENF"
          type="date"
          class="field"
          :disabled="configInputs"
        />
      </div>
      <div class="section-field">
        <label class=""> Chegada do Molde </label>
        <input
          v-model="v$.dados.IGDCM.$model"
          type="date"
          :class="['field', { error: v$.dados.IGDCM.$error }]"
          :disabled="configInputs"
        />
        <div class="text-red" v-if="v$.dados.IGDCM.$error">
          O campo Chegada do Molde é obrigatório.
        </div>
      </div>
      <div class="section-field">
        <label class="">Abertura do Molde </label>
        <input
          v-model="v$.dados.IGDAM.$model"
          type="date"
          :class="['field', { error: v$.dados.IGDAM.$error }]"
          :disabled="configInputs"
        />
        <div class="text-red" v-if="v$.dados.IGDAM.$error">
          O campo Abertura do Molde é obrigatório.
        </div>
      </div>
      <!-- <div class="section-field">
        <label class="">
          Tryout do Molde
        </label>
        <input
          v-model="dados.IGDTM"
          type="date"
          class="field"
          :disabled="configInputs"
        />
      </div> -->

      <div class="section-field">
        <label class=""> Código BR do Molde </label>
        <input
          v-model="dados.IGCMC"
          :placeholder="configInputs == 0 ? 'Digite o código' : ''"
          type="text"
          class="field"
          :disabled="configInputs"
        />
        <!-- <div class="text-red" v-if="v$.dados.IGCMC.$error">
          O campo Código é obrigatório.
        </div> -->
      </div>
      <div>
        <div class="section-field" v-if="configInputs == 0">
          <label class=""> Molde Familia </label>
          <select
            v-model="dados.molde_familia"
            id="molde_familia"
            class="field_select"
          >
            <option value="" disabled selected>Selecione uma opção</option>
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select>
        </div>
        <div class="section-field" v-else-if="configInputs == 1">
          <label for="molde_familia">Molde Familia:</label>
          <select
            disabled
            v-model="dados.molde_familia"
            id="molde_familia"
            class="field_select"
          >
            <option
              :value="dados.molde_familia"
              style="color: var(--font_color)"
            >
              {{ dados.molde_familia ? "Sim" : "Não" }}
            </option>
          </select>
        </div>
        <div class="section-field" v-else>
          <label for="molde_familia">Molde Familia:</label>
          <select
            v-model="dados.molde_familia"
            id="molde_familia"
            class="field_select"
          >
            <option disabled value="">Selecione uma opção</option>
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select>
        </div>
      </div>

      <div
        class="section-field"
        style="width: 17rem"
        v-show="configInputs == 0"
      ></div>
    </div>
    <div class="section-caf">
      <div>
        <label class=""> Foto do CAF </label>
        <div>
          <div v-if="imageData[0] != undefined" style="position: relative">
            <div class="removeimage" v-if="configInputs != 1">
              <div class="closeimage" @click="resetFile(0)"></div>
            </div>
            <img
              :src="`${imageData[0]}`"
              class="container"
              @click="clickPreview(imageData[0])"
            />
          </div>
          <div class="image-preview" v-else>
            <div v-if="!configInputs">
              <label for="fotocaf">
                <div class="image"></div>
              </label>
              <input
                type="file"
                accept="image/*"
                id="fotocaf"
                multiple
                hidden
                @change="previewFiles($event)"
              />
            </div>
            <div v-else>
              <div class="empty"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-field">
        <label class=""> Código CAF do Molde </label>
        <input
          v-model="fotoCAF.description"
          :placeholder="configInputs == 0 ? 'Digite o código' : ''"
          type="text"
          class="field"
          :disabled="configInputs"
        />
      </div>

      <!-- {{ fotoCAF }} -->
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { minLength, required } from "@vuelidate/validators";
import dayjs from "dayjs";
import { sap } from "../../../../../../http/index";
import InputI1E from "../../../../../Inputs-defaults/Inp-1-emit.vue";
import InputI1 from "../../../../../Inputs-defaults/Inp-1.vue";

export default {
  components: { InputI1, InputI1E },
  async created() {
    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
    }
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      CavityMolde: Number,
      moldFound: false,
      listMoldes: [],
      rrim: "",
      validationMolde: false,
      dados: {
        // IGDTM: "Default",
        IGDAM: "",
        IGDCM: "",
        IGFM: "",
        IGCMC: "",
        IGCCF: "",
        IGENF: null,
        IGNF: "",
        IGCliente: "",
        IGMolde: "",
        IGRRIM: "MD-PADRÃO",
        molde_familia: "",
      },
      imageIG: [],
      imageData: [],
      fotoCAF: {
        file: [],
        description: "",
      },
    };
  },

  props: {
    configInputs: Number,
    dadosQuery: Object,
  },

  validations() {
    return {
      dados: {
        IGRRIM: {
          required,
          minLength: minLength(4),
        },

        IGMolde: {
          required,
          minLength: minLength(4),
        },

        IGCliente: {
          required,
          minLength: minLength(4),
        },
        IGDCM: {
          required,
          minValue(val) {
            if (new Date(val) >= new Date()) {
              const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });

              Toast.fire({
                icon: "info",
                title: "Data de Chegada de Molde",
                text: "Data maior que a atual",
              });

              return false;
            }
            return true;
          },
        },
        IGDAM: {
          required,
          minValue(val) {
            if (new Date(val) < new Date(this.dados.IGDCM)) {
              const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });

              Toast.fire({
                icon: "info",
                title: "Data de Abertura do Molde",
                text: "Data menor do que a data de chegada do molde.",
              });

              return false;
            }
            return true;
          },
        },
      },
    };
  },
  methods: {
    async mapMoldSap(molde) {
      const mold = molde.trim();

      const showToast = async (icon, title) => {
        const Toast = await this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        Toast.fire({ icon, title });
      };

      if (!mold) {
        await showToast("error", "Digite um Molde");
        return;
      }

      try {
        const { data: moldeSap } = await sap.get("/mold/", {
          params: {
            unidade: "JPA",
            mold_code: mold,
          },
        });

        if (!moldeSap || moldeSap.length === 0) {
          this.listMoldes = [];
          await showToast("error", "Molde não encontrado");
          return;
        }

        this.validationMolde = false;
        this.listMoldes = moldeSap;
        this.moldFound = true;
        this.$emit("mapMoldSap", moldeSap[0].cavidade);
        this.$emit("mold-found", true);
      } catch (error) {
        console.error("Erro ao buscar molde:", error.message);
        await showToast("error", "Erro, molde não encontrado");
      }
    },
    ReformDate(date) {
      if (date === null) {
        return null;
      }
      const dataFormatada = dayjs(date).add(1, "days").format("YYYY-MM-DD");
      return dataFormatada;
    },
    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;

      if (dataQuery.InforGeral) {
        this.dados.IGDAM = this.ReformDate(
          dataQuery.InforGeral.DT_ABERTURA_MOLDE
        );
        this.dados.IGDCM = this.ReformDate(
          dataQuery.InforGeral.DT_CHEGADA_MOLDE
        );
        this.dados.IGFM = dataQuery.InforGeral.FABRICANTE_MOLDE;
        this.dados.IGCMC = dataQuery.InforGeral.CODIGO_MOLDE;
        this.dados.IGCCF = dataQuery.InforGeral.CODIGO_MOLDE_CAF;
        this.dados.molde_familia = dataQuery.InforGeral.molde_familia;
        this.dados.IGENF = this.ReformDate(dataQuery.InforGeral.EMISSAO);
        this.dados.IGNF = dataQuery.InforGeral.NOTA_FISCAL;

        this.dados.IGCliente = dataQuery.InforGeral.CLIENTE;
        this.dados.IGMolde = dataQuery.InforGeral.MOLDE;
        this.dados.IGRRIM = "RRIM-" + dataQuery.InforGeral.ID;
        if (
          dataQuery.ImagesRRIM &&
          dataQuery.ImagesRRIM.length > 0 &&
          dataQuery.ImagesRRIM[0].IMAGEM_CAF_DESC &&
          String(dataQuery.ImagesRRIM[0].IMAGEM_CAF_DESC).trim() !== ""
        ) {
          this.fotoCAF.description = dataQuery.ImagesRRIM[0].IMAGEM_CAF_DESC;
        } else {
          this.fotoCAF.description = dataQuery.InforGeral.CODIGO_MOLDE_CAF;
        }
        if (dataQuery.ImagesRRIM[0].IMAGEM_CAF) {
          this.imageData[0] =
            `${this.$store.state.ImgURL}` +
            `${dataQuery.ImagesRRIM[0].IMAGEM_CAF}`;
          this.fotoCAF.file = dataQuery.ImagesRRIM[0].IMAGEM_CAF;
        }
      }
    },
    previewFiles(event) {
      const input = event.target;

      if (input.files && input.files[0]) {
        const file = input.files[0];
        if (!file.type.startsWith("image/")) {
          this.$swal.fire({
            icon: "error",
            title: "Arquivo inválido",
            text: "Por favor, selecione apenas arquivos de imagem.",
            confirmButtonColor: "#e74c3c",
          });
          input.value = "";
          return;
        }

        this.fotoCAF.file = file;

        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData[0] = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    clickPreview(base64) {
      this.$swal
        .fire({
          imageUrl: base64,
          imageAlt: "Imagem carregada",
          confirmButtonText: "Baixar",
          showCloseButton: true,
          background: "#fff",
          customClass: {
            popup: "preview-modal-popup",
            image: "preview-modal-image",
            confirmButton: "preview-modal-button",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            const link = document.createElement("a");
            link.href = base64;
            link.download = "imagem.jpg";
            link.click();
          }
        });
    },
    resetFile(position) {
      this.imageData[position] = null;
      this.fotoCAF.file = [];

      // this.$emit("setFotosAbertEmb",this.FormDataImages)
    },
  },
  watch: {
    dados: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        const lista = this.dados;
        this.$emit("OBJ_Infor_Geral", this.dados);
      },
    },
    "dados.molde_familia": {
      immediate: true,
      handler(val) {
        if (val === "true") this.dados.molde_familia = true;
        else if (val === "false") this.dados.molde_familia = false;
      },
    },
    fotoCAF: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        const assot = this.$store.getters.GetCAF;
        this.dados.IGCCF = assot.description;
        this.$store.commit("MutationCAF", newValue);
      },
    },
  },
};
</script>

<style scoped>
.container {
  width: 16rem !important;
  height: 16rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  overflow: hidden;
  object-fit: cover;
  cursor: pointer;
}

.row-1 {
  display: grid;
  color: var(--font_color);
  margin-bottom: 1rem;
  grid-template-columns: 1fr 1fr;
  gap: 1.1rem;
}

.image {
  background-color: var(--bgProcess);
  background-image: url(../../../../../../static/icons/+_black.svg);
  width: 16rem !important;
  height: 16rem !important;
  border-radius: 1rem;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 12%;
}

.image:hover {
  background-color: rgb(156, 150, 150);
}

.closeimage {
  width: 24px;
  height: 24px;
  background: url(../../../../../../static/icons/closeimage.svg) no-repeat
    center;
  background-size: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  cursor: pointer;
}

.removeimage {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 3;
  cursor: pointer;
}

.section_image {
  display: inline-block;
  max-width: 11rem !important;
}

.section-caf {
  display: flex;
  align-items: center;
  flex-direction: column !important;
  gap: 1.1rem;
}

.palavra1:hover {
  background-color: rgb(156, 150, 150);
}

label {
  font-size: 0.7rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
}

.field {
  border-radius: 10px !important;
  border: 2px solid #d9d9d9 !important;
  height: 2.5rem !important;
  width: 17rem !important;
  padding: 1rem;
  color: var(--font_color);
  cursor: text;
}

.field_select {
  border-radius: 10px !important;
  border: 2px solid #d9d9d9;
  height: 2.5rem !important;
  width: 17rem !important;
  color: var(--font_color);
  padding-left: 1rem;
  cursor: pointer;
}

#molde_familia option {
  color: var(--font_color);
  background-color: #ffffff;
  border-radius: 5rem !important;
  border: none !important;
  box-shadow: 1px 1px 1px 0px !important;
}

#molde_familia option:hover {
  background-color: #e0e0e0 !important;
}

#molde_familia option:checked {
  background-color: var(--font_color);
  border-radius: 5rem !important;
  color: white !important;
}

.field:hover {
  border: 1px solid var(--input_hover) !important;
  transition: border-color 0.5s ease;
}

.field:focus {
  border: 1px solid var(--green) !important;
}

.field::placeholder {
  color: rgb(65, 62, 62) !important;
}

.section-field {
  display: flex;
  flex-direction: column;
}

.error {
  border-radius: 10px !important;
  padding: 1rem;
  color: var(--font_color);
  border: 1px solid red !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.text-red {
  color: red;
  font-size: 0.8rem;
  width: 100% !important;
  text-align: center !important;
}

.empty {
  background-image: url("../../../../../../static/icons/empty-image.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 40%;
  width: 12rem;
  height: 12rem;
  border: 2px solid #757575;
  border-radius: 1rem;
}

@media (max-width: 1266px) {
  .row-1,
  .row-2 {
    grid-template-columns: 1fr 1fr 1fr;
    width: 100% !important;
  }

  .section-field {
    width: 100%;
  }

  .field {
    width: 100%;
  }
}

@media (max-width: 1205px) {
  .row-1,
  .row-2 {
    grid-template-columns: 1fr 1fr 1fr;
    width: 100% !important;
  }
  .section-field {
    width: 15rem;
  }

  .field,
  .field_select {
    width: 100% !important;
  }
}

@media (max-width: 983px) {
  .row-1,
  .row-2 {
    grid-template-columns: 1fr 1fr;
    width: 100% !important;
  }

  .section-field {
    width: 18rem;
  }

  .field,
  .field_select {
    width: 100% !important;
  }
}

@media (max-width: 743px) {
  .section-field {
    width: 15rem;
  }

  .field,
  .field_select {
    width: 100% !important;
  }
}

@media (max-width: 638px) {
  .row-1,
  .row-2 {
    grid-template-columns: 1fr;
    width: 100% !important;
  }

  .section-field {
    width: 100% !important;
  }
}
</style>
